module.exports = __webpack_public_path__ + "static/media/partnership.f472eebc.png";